import api from '.'

/**
 * SettingsApi class to handle settings-related API requests.
 * This class provides methods to interact with the API for fetching or modifying settings based on different parameters
 * like country code and campaign type.
 */
class SettingsApi {
    /**
     * Sends a campaign request to the server.
     *
     * @returns {Promise<object>} A promise that resolves to the response data from the server or the catch response in case
     * of an error.
     */
    campaign() {
        const payload = {}

        return api
            .sentRequest('/api/settings/campaign', payload, true)
            .then((res) => {
                return res.data
            })
            .catch((err) => {
                console.error('[Auth Api]: ', err)
                return api.getCatchResponse(err)
            })
    }

    /**
     * Initializes default settings by sending a request to the server.
     *
     * @returns {Promise<object>} A promise that resolves to the response data from the server or the catch response in case of an error.
     */
    initialize() {
        const payload = {}

        return api
            .sentRequest('/api/settings/default', payload, true)
            .then((res) => {
                return res.data
            })
            .catch((err) => {
                console.error('[Auth Api]: ', err)
                return api.getCatchResponse(err)
            })
    }

    /**
     * Sends a campaign type request to the server based on the country code and campaign type.
     *
     * @param {string} country_code - The country code for which the campaign type request is being made.
     * @param {string} campaign_type - The campaign type for which the request is being made.
     * @returns {Promise<object>} A promise that resolves to the response data from the server or the catch response in case of an error.
     */
    byCountryCampaignType(country_code, campaign_type) {
        const payload = {
            country_code,
            campaign_type
        }

        return api
            .sentRequest('/api/settings/campaign_type', payload, true)
            .then((res) => {
                return res.data
            })
            .catch((err) => {
                console.error('[Auth Api]: ', err)
                return api.getCatchResponse(err)
            })
    }

    /**
     * Sends a status update request to the server.
     *
     * @returns {Promise<object>} A promise that resolves to the response data from the server or the catch response in case of an error.
     */
    statusUpdate() {
        const payload = {}

        return api
            .sentRequest('/api/settings/status-update', payload, true)
            .then((res) => {
                return res.data
            })
            .catch((err) => {
                console.error('[Auth Api]: ', err)
                return api.getCatchResponse(err)
            })
    }
}

export const settingsApi = new SettingsApi()
